//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    /*
      Variables used by the drag and drop component
    */
    props: {
        website: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        changeMethod: {
            type: String,
            default: ''
        },
        image: null
    },
    data: function data() {
        return {
            loading: null,
            imageData: null,
            uploadFieldName: '',
            dragAndDropCapable: false,
            files: [],
            uploadPercentage: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.dragAndDropCapable = this.determineDragAndDropCapable();
        this.refresh();

        Event.$on('show-existing-image', function (fileURL) {
            console.log('clear files array, set to []');
            _this.files = [];
            console.log('show-existing-image Setting imageData to ' + fileURL);
            _this.imageData = fileURL;
            console.log(_this.image);
        });

        Event.$on('show-upload-image', function () {
            console.log('show-upload-image Setting imageData to false');
            _this.files = [];
            _this.imageData = null;
        });
    },


    methods: {
        onSelectFile: function onSelectFile(event) {
            var _this2 = this;

            console.log('CMSdsingle onSelectFile(event) , event = ' + event);
            var input = this.$refs.fileInput;
            var files = input.files;
            if (files && files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    _this2.imageData = e.target.result;
                };
                reader.readAsDataURL(files[0]);
                this.$emit('input', files[0]);
            }
        },
        emitAction: function emitAction(event) {
            console.log('CMSdsingle emitAction(event) , changeMethod = ' + this.changeMethod + ' + event = ' + event);
            //this.$emit(this.changeMethod, event)
            Event.$emit(this.changeMethod, event);
        },
        refresh: function refresh() {
            console.log('CMSdsingle refresh()');
            console.log('clear files array, set to []');
            this.files = [];
            if (this.dragAndDropCapable) {
                ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
                    this.$refs.fileform.addEventListener(evt, function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }.bind(this), false);
                }.bind(this));

                this.$refs.fileform.addEventListener('drop', function (e) {
                    /*
                     Capture the files from the drop event and add them to our local files
                     array.
                     */
                    this.files = [];
                    for (var i = 0; i < e.dataTransfer.files.length; i++) {
                        if (i == 0) {
                            this.files.push(e.dataTransfer.files[i]);
                            this.getImagePreviews();

                            this.emitAction(e);
                        }
                    }
                }.bind(this));
            }
        },
        determineDragAndDropCapable: function determineDragAndDropCapable() {
            console.log('CMSdsingle determineDragAndDropCapable()');
            var div = document.createElement('div');
            return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
        },
        getImagePreviews: function getImagePreviews() {
            var _this3 = this;

            console.log('CMSdsingle getImagePreviews()');
            /*
              Iterate over all of the files and generate an image preview for each one.
            */

            var _loop = function _loop(i) {
                /*
                  Ensure the file is an image file
                */
                if (/\.(jpe?g|png|gif)$/i.test(_this3.files[i].name)) {
                    var reader = new FileReader();

                    reader.addEventListener("load", function () {
                        this.$refs['preview' + parseInt(i)][0].src = reader.result;
                    }.bind(_this3), false);

                    reader.readAsDataURL(_this3.files[i]);
                } else {
                    _this3.$nextTick(function () {
                        this.$refs['preview' + parseInt(i)][0].src = '/images/file.png';
                    });
                }
            };

            for (var i = 0; i < this.files.length; i++) {
                _loop(i);
            }
        },
        submitFiles: function submitFiles() {
            var _this4 = this;

            console.log('CMSDragAndDrop.vue submitFiles()');
            var formData = new FormData();

            formData.append('galleryName', this.galleryName);

            if (this.image) {
                formData.append('photo_id', this.image.id);
            }

            for (var i = 0; i < this.files.length; i++) {
                var file = this.files[i];

                formData.append('files[' + i + ']', file);
            }
            this.loading = 'Upload image to server..';
            this.files = [];
            //need to update this post
            axios.post('/prototype/website/' + this.website.id + '/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                    this.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                }.bind(this)
            }).then(function (response) {
                // add a delay here
                console.log('delay to allow CDN to process -small version of image......');
                _this4.loading = 'Resizing and processing thumbnail versions of image...';
                setTimeout(function () {
                    console.log('setTimeout reached');
                    console.log('MediaSlideOut galleryName = ' + _this4.galleryName + ' refresh website property id = ' + _this4.website.property_id);
                    _this4.loading = false;
                    Event.$emit('refresh-property-website', _this4.website.property_id);
                    Event.$emit('close-media-slideout');
                    Event.$emit('img-uploader-hide-media-gallery');
                    Event.$emit('open-media-folder', _this4.galleryName);
                }, 10000);
            }).catch(function () {
                alert('Uh Oh!!');
            });
        },


        /*
          Removes a select file the user has uploaded
        */
        removeFile: function removeFile(key) {
            console.log('CMSdsingle removeFile(key), key = ' + key);
            this.files.splice(key, 1);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/CMSDragAndDropSingle.vue
// module id = vUax
// module chunks = 0 1